const { toDate, toInt, toNullableInt, toNullableString, toString } = require('@/functions/transform');

class PaymentToken {
    constructor() {
        /**
         * @type {Number}
         */
        this.ID = null;

        /**
         * @type {string|null}
         */
        this.authorisationReference = null;

        /**
         * @type {string|null}
         */
        this.cardType = null;

        /**
         * @type {string|null}
         */
        this.cardTypeRef = null;

        /**
         * @type {number|null}
         */
        this.customerAccountID = null;

        /**
         * @type {Date|null}
         */
        this.effectiveFrom = null;

        /**
         * @type {string|null}
         */
        this.lastDigits = null;

        /**
         * @type {string|null}
         */
        this.paymentMechanismReference = null;

        /**
         * @type {number|null}
         */
        this.paymentMethodID = null;

        /**
         * @type {string}
         */
        this.reference = '';
    }

    getHydrationMap() {
        return {
            authorisationReference: toNullableString,
            cardType: {},
            cardTypeRef: {},
            customerAccountID: toNullableInt,
            effectiveFrom: toDate,
            ID: {
                field: ['customerAccountPaymentTokenID', 'ID'],
                transform: toInt,
            },
            lastDigits: toNullableString,
            paymentMechanismReference: {},
            paymentMethodID: toNullableInt,
            reference: toString,
        };
    }
}

module.exports = PaymentToken;
